export const GET_MANAGE_PROFILE_SUCCESS="GET_MANAGE_PROFILE_SUCCESS";

export const UPDATE_PHONE_NUMBER="UPDATE_PHONE_NUMBER";
export const UPDATE_USER_INFO_SUCCESS="UPDATE_USER_INFO_SUCCESS";

export const UPDATE_USER_DATA="UPDATE_USER_DATA";

export const UPDATE_AU_SETTINGS = "UPDATE_AU_SETTINGS";
export const UPDATE_AU_SETTINGS_SUCCESS = "UPDATE_AU_SETTINGS_SUCCESS";

export const RESET_USER_INFO="RESET_USER_INFO";
export const SET_UPDATING_DATA="SET_UPDATING_DATA";
export const UPDATE_TIME_ZONE="UPDATE_TIME_ZONE";
export const CREATE_USER_LICENSE="CREATE_USER_LICENSE";
export const UPDATE_USER_LICENSE="UPDATE_USER_LICENSE";
export const DELETE_USER_LICENSE="DELETE_USER_LICENSE";
export const CREATE_USER_LICENSE_SUCCESS = "CREATE_USER_LICENSE_SUCCESS";
export const UPDATE_USER_LICENSE_SUCCESS = "UPDATE_USER_LICENSE_SUCCESS";
export const DELETE_USER_LICENSE_SUCCESS = "DELETE_USER_LICENSE_SUCCESS";
export const GET_USER_INFO = "GET_USERS_INFO";

export const GET_NOTIFICATION_SETTINGS = "GET_NOTIFICATION_SETTINGS";
export const GET_NOTIFICATION_SETTINGS_SUCCESS = "GET_NOTIFICATION_SETTINGS_SUCCESS";
export const GET_NOTIFICATION_SETTINGS_FAILURE = "GET_NOTIFICATION_SETTINGS_FAILURE";

export const UPDATE_NOTIFICATION_SETTINGS = "UPDATE_NOTIFICATION_SETTINGS";
export const UPDATE_NOTIFICATION_SETTINGS_SUCCESS = "UPDATE_NOTIFICATION_SETTINGS_SUCCESS";
export const UPDATE_NOTIFICATION_SETTINGS_FAILURE = "UPDATE_NOTIFICATION_SETTINGS_FAILURE";